/**
 * DOM event asking the Command Hub bell (EmailNotificationContext) to refetch.
 *
 * Dispatched by SignalFeedContext when a real-time "system" notification
 * arrives over SSE (GitHub #1054): those are bell-only now, and the bell
 * otherwise polls every 10 minutes.
 */
export const BELL_REFRESH_EVENT = 'delfin:bell-refresh';
